export function pickHeader(headerTheme) {
  switch(headerTheme) {
    case "header": return import(/* webpackChunkName: "header" */ './components/header-components/header');
  }
}